import { declareParams, JsonApiRequestError } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createStore, Store } from 'effector';
import { RegistryParams, RegistryQuery } from 'shared/lib';
import { createAuthQuery } from '../auth-http-client';
import { Voucher, voucherSchema, createPaginatedSchema } from '../types';

export type OriginalVoucherRegistryParams = {
	sortField?: string | null;
	sortDirection?: string;
	page?: number;
	limit?: number;
	currencies?: string[];
	accountIds?: string[];
};

export type VoucherRegistryFilters = {
	currencies: string[];
	accountIds: number[];
};

export type VoucherRegistryParams = RegistryParams<VoucherRegistryFilters>;

export type VoucherRegistryQuery = RegistryQuery<
	Voucher,
	VoucherRegistryFilters,
	JsonApiRequestError
>;

export const createVoucherRegistryQuery = (
	$accountId?: Store<number | null>,
): VoucherRegistryQuery => {
	const query = createAuthQuery({
		params: declareParams<VoucherRegistryParams>(),
		request: {
			method: 'GET',
			url: '/voucher/list',
			query: {
				source: $accountId ?? createStore(null),
				fn: (params, accountId) => ({
					page: params.page,
					limit: params.limit,
					sortField: params.sortField ?? undefined,
					sortDirection: params.sortDirection,
					currencies:
						params.filters.currencies?.length === 0 ? undefined : params.filters.currencies,
					accountIds: [
						...(accountId ? [String(accountId)] : []),
						...params.filters.accountIds.map(String),
					],
				}),
			},
		},
		response: {
			contract: zodContract(createPaginatedSchema(voucherSchema)),
		},
	});

	return query;
};
